import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Form from '../common/Form';
import Pager from '../common/Pager';
import useApiList from '../../hooks/useApiList';
import { PAGE_LIMIT } from '../../config';
import icon_root from '../../assets/root.png';
import icon_admin from '../../assets/admin.png';
import icon_agent from '../../assets/agent.png';
import icon_exhibitor from '../../assets/exhibitor.png';

const icon = {
		root: icon_root,
		admin: icon_admin,
		agent: icon_agent,
		exhibitor: icon_exhibitor,
};

const UserList = () => {
	const limit = PAGE_LIMIT;
	const method = '/users';
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [ find, setFind ] = useState('');
	const [ role, setRole ] = useState('');
	const [ skip, setSkip ] = useState(0);
	const [ data, error, isLoading ] = useApiList({ method, limit, find, skip, role });

	const onChangeRole = (e) => {
		setRole(e.target.value);
		setSkip(0);
	};

	return (
		<div>
	    	<h1>{t('userlist.title')}</h1>
			<Form error={error}>
				<div className='Form-row'>
					<input
						type='text'
						value={find}
						placeholder={t('userlist.placeholder')}
						onChange={e => setFind(e.target.value)}
					/>
					<div
						className='submit'
						onClick={() => navigate('/cabinet/useradd')}
					>
						<Icon icon={faPlus}/>
					</div>
				</div>
                <fieldset id='role'>
					<input
                        id='radioAll'
                        type='radio'
                        value=''
                        name='role'
                        checked={role === ''}
                        onChange={onChangeRole}
                    />
                    <label htmlFor='radioAll'>{t('user.all')}</label>
                    <input
                        id='radioRoot'
                        type='radio'
                        value='root'
                        name='role'
                        checked={role === 'root'}
                        onChange={onChangeRole}
                    />
                    <label htmlFor='radioRoot'>{t('user.root_short')}</label>
                    <input
                        id='radioAdmin'
                        type='radio'
                        value='admin'
                        name='role'
                        checked={role === 'admin'}
                        onChange={onChangeRole}
                    />
                    <label htmlFor='radioAdmin'>{t('user.admin_short')}</label>
                    <input
                        id='radioExhibitor'
                        type='radio'
                        value='exhibitor'
                        name='role'
                        checked={role === 'exhibitor'}
                        onChange={onChangeRole}
                    />
                    <label htmlFor='radioExhibitor'>{t('user.exhibitor_short')}</label>
                    <input
                        id='radioAgent'
                        type='radio'
                        value='agent'
                        name='role'
                        checked={role === 'agent'}
                        onChange={onChangeRole}
                    />
                    <label htmlFor='radioAgent'>{t('user.agent_short')}</label>
                </fieldset>
			</Form>

			{isLoading ? <span>{t('common.loading')}</span> :
			<React.Fragment>
				{data &&
				<React.Fragment>
					<div>
						{data.total ? t('userlist.found') + data.total : t('userlist.notfound')}
					</div>
					<div className='list'>
						{data.users.map(user => (
							<div
								key={user._id}
								className='item'
								onClick={() => navigate('/cabinet/userview/' + user._id)}
							>
								<img
									className='icon'
									alt='icon'
									src={icon[user.role]}
									style={{backgroundColor:'var(--main-color)'}}
								/>
								<div className='text'>
									<div>{user.name}</div>
                					<small>{user.email}</small>
								</div>
							</div>
						))}
					</div>
					<Pager total={data.total} skip={skip} limit={limit} setSkip={setSkip}/>
				</React.Fragment>}
			</React.Fragment>}

			<Form>
				<input
					type='submit'
					value={t('userlist.adduser')}
					onClick={() => navigate('/cabinet/useradd')}
				/>
			</Form>
		</div>
	);
};

export default UserList;
